import jsonURL from 'json-url';

const codec = jsonURL('lzw');

export async function decompressData(data: string) {
  const decompressedData = await codec.decompress(data);

  return decompressedData;
}
